
import Button from '../../../components/base/Button';

export default function ProductsHeroSection() {
  const handleTrustSystemClick = () => {
    window.REACT_APP_NAVIGATE('/trust');
  };

  const handleBrowseAllProductsClick = () => {
    const targetElement = document.getElementById('all-products-section');
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-[600px] bg-cover bg-center bg-no-repeat flex items-center"
      style={{
        backgroundImage: `linear-gradient(rgba(102, 51, 51, 0.7), rgba(102, 51, 51, 0.7)), url('https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/bbb922afb5c5b05504eca6e8ca3b1ca8.jfif')`
      }}
    >
      <div className="w-full mx-auto px-6 lg:px-[15%]">
        <div className="max-w-3xl">
          <h1 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 leading-tight">
            产品中心
          </h1>
          <p className="text-sm sm:text-lg lg:text-xl text-white/90 mb-8 leading-relaxed">
            精选年份茶，匠心制作每一款茶品
            <br />
            传承古法工艺，呈现时光之美
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              variant="primary" 
              size="lg" 
              className="rounded-full bg-[#cc9966] hover:bg-[#bb8855] text-white px-8 text-sm sm:text-lg"
              onClick={handleBrowseAllProductsClick}
            >
              浏览全部产品
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="rounded-full border-white text-white hover:bg-white hover:text-[#663333] px-8 text-sm sm:text-lg"
              onClick={handleTrustSystemClick}
            >
              年份茶信任体系
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
